import React from 'react'
import { Route, Switch } from 'react-router-dom'
// import Dashboard from './pages/dashboard'
// import Typography from './pages/typography'
// import Tables from './pages/tables'
// import Notifications from './pages/notifications'
// import Icons from './pages/icons'
// import Maps from './pages/maps'
// import Charts from './pages/charts/Charts'
import Home from './pages/Home'
import NoMatch from './pages/NoMatch'
import EditProfile from './pages/EditProfile'
import PrivateRoute from './utils/PrivateRoute'
import UnAuthorized from './pages/UnAuthorized'

// Common Components
import AddAdmin from './pages/User/AddAdmin'
import Pages from './pages/Pages'
import SinglePageAdd from './pages/Pages/SinglePage/Add'
import SinglePageEdit from './pages/Pages/SinglePage/Edit'
import Roles from './pages/Roles'
import SingleRoleAdd from './pages/Roles/SingleRole/Add'
import SingleRoleEdit from './pages/Roles/SingleRole/Edit'
import Settings from './pages/Settings'

// Workspace Components
import UserEditProfile from './pages/Workspace/User/EditProfile'
import UserCompanies from './pages/Workspace/User/Companies'
import PaymentRequests from './pages/Workspace/PaymentRequests'
import PaymentReceipts from './pages/Workspace/PaymentReceipts'
import ActivityLog from './pages/Workspace/ActivityLog'
import Companies from './pages/Workspace/Companies'
import CompanyUsers from './pages/Workspace/Companies/Users'
import Users from './pages/Workspace/User/Users'
import PaymentClaims from './pages/Workspace/PaymentClaims'
import UPTCP from './pages/Workspace/UPTCP'
import Currencies from './pages/Workspace/Currencies'
import SingleCurrencyAdd from './pages/Workspace/Currencies/Add'
import SingleCurrencyEdit from './pages/Workspace/Currencies/Edit'

// {/*Subscription Components*/}
import SubscriptionUsers from './pages/Subscription/User/Users'
import SubscriptionActivityLog from './pages/Subscription/ActivityLog'
import Categories from './pages/Subscription/Categories'
import SingleCategoryAdd from './pages/Subscription/Categories/SinglePage/Add'
import SingleCategoryEdit from './pages/Subscription/Categories/SinglePage/Edit'
import Services from './pages/Subscription/Services'
import SingleServiceAdd from './pages/Subscription/Services/SinglePage/Add'
import SingleServiceEdit from './pages/Subscription/Services/SinglePage/Edit'
import Plans from './pages/Subscription/Plans'
import SinglePlanAdd from './pages/Subscription/Plans/SinglePage/Add'
import SinglePlanEdit from './pages/Subscription/Plans/SinglePage/Edit'
import SubscriptionPaymentRequests from './pages/Subscription/PaymentRequests'
import PlansReport from './pages/Subscription/PlansReport'
import ServicesReport from './pages/Subscription/ServicesReport'
import SubscriptionsReport from './pages/Subscription/SubscriptionsReport'
import SubscriptionPaymentReceipts from './pages/Subscription/PaymentReceipts'
import UserGroups from './pages/Subscription/UserGroups'
import SingleUserGroupAdd from './pages/Subscription/UserGroups/SinglePages/Add'
import SingleUserGroupEdit from './pages/Subscription/UserGroups/SinglePages/Edit'
import ExternalEntityGroups from './pages/Subscription/ExternalEntityGroup'
import SingleExternalEntityGroupAdd from './pages/Subscription/ExternalEntityGroup/SinglePages/Add'
import SingleExternalEntityGroupEdit from './pages/Subscription/ExternalEntityGroup/SinglePages/Edit'
import SinglePromocodeEdit from './pages/Subscription/Promocodes/SinglePages/Edit'
import SinglePromocodeAdd from './pages/Subscription/Promocodes/SinglePages/Add'
import Promocodes from './pages/Subscription/Promocodes'

export const coreRoutes = {
  workspace: '/workspace',
  subscription: '/subscription'
}

export const NamedRoutes = {
  home: `/`,
  editProfile: '/profile/edit',
  unAuthorized: '/unauthorized',
  workspace: {
    home: coreRoutes.workspace,
    user: {
      list: coreRoutes.workspace,
      editProfile: `${coreRoutes.workspace}/user/:id/profile/edit`,
      companies: `${coreRoutes.workspace}/user/:id/companies`,
      addAdmin: `${coreRoutes.workspace}/user/add`
    },
    company: {
      list: `${coreRoutes.workspace}/companies`,
      users: `${coreRoutes.workspace}/company/:id/users`
    },
    payments: `${coreRoutes.workspace}/payment-claims`,
    paymentRequests: `${coreRoutes.workspace}/payment-requests`,
    paymentReceipts: `${coreRoutes.workspace}/payment-receipts`,
    currencies: {
      list: `${coreRoutes.workspace}/currencies`,
      add: `${coreRoutes.workspace}/currency/add`,
      edit: `${coreRoutes.workspace}/currency/:id/edit`
    },
    ActivityLog: `${coreRoutes.workspace}/activity-log`,
    settings: `${coreRoutes.workspace}/settings`,
    page: {
      list: `${coreRoutes.workspace}/pages`,
      edit: `${coreRoutes.workspace}/page/:id/edit`,
      add: `${coreRoutes.workspace}/page/add`
    },
    RolesAndPermissions: {
      list: `${coreRoutes.workspace}/roles-and-permissions`,
      edit: `${coreRoutes.workspace}/roles-and-permissions/:id/edit`,
      add: `${coreRoutes.workspace}/roles-and-permissions/add`
    },
    uptcp: `${coreRoutes.workspace}/uptcp`,
  },
  subscription: {
    home: coreRoutes.subscription,
    user: {
      list: coreRoutes.subscription,
      addAdmin: `${coreRoutes.subscription}/user/add`,
      editProfile: `${coreRoutes.subscription}/user/:id/profile`,
      // companies: `${coreRoutes.workspace}/user/:id/companies`,
    },
    category: {
      list: `${coreRoutes.subscription}/categories`,
      edit: `${coreRoutes.subscription}/category/:id/edit`,
      add: `${coreRoutes.subscription}/category/add`
    },
    service: {
      list: `${coreRoutes.subscription}/services`,
      edit: `${coreRoutes.subscription}/service/:id/edit`,
      add: `${coreRoutes.subscription}/service/add`
    },
    plan: {
      list: `${coreRoutes.subscription}/plans`,
      edit: `${coreRoutes.subscription}/plan/:id/edit`,
      add: `${coreRoutes.subscription}/plan/add`
    },
    paymentRequests: `${coreRoutes.subscription}/payment-requests`,
    paymentReceipts: `${coreRoutes.subscription}/payment-receipts`,
    ActivityLog: `${coreRoutes.subscription}/activity-log`,
    settings: `${coreRoutes.subscription}/settings`,
    page: {
      list: `${coreRoutes.subscription}/pages`,
      edit: `${coreRoutes.subscription}/page/:id/edit`,
      add: `${coreRoutes.subscription}/page/add`
    },
    report: {
      home: `${coreRoutes.subscription}/report`,
      plans: `${coreRoutes.subscription}/report/plans`,
      services: `${coreRoutes.subscription}/report/services`,
      subscriptions: `${coreRoutes.subscription}/report/subscriptions`
    },
    RolesAndPermissions: {
      list: `${coreRoutes.subscription}/roles-and-permissions`,
      edit: `${coreRoutes.subscription}/roles-and-permissions/:id/edit`,
      add: `${coreRoutes.subscription}/roles-and-permissions/add`
    },
    userGroups: {
      list: `${coreRoutes.subscription}/user-groups`,
      edit: `${coreRoutes.subscription}/user-groups/:id/edit`,
      add: `${coreRoutes.subscription}/user-group/add`
    },
    externalEntityGroups: {
      list: `${coreRoutes.subscription}/external-entity-groups`,
      edit: `${coreRoutes.subscription}/external-entity-group/:id/edit`,
      add: `${coreRoutes.subscription}/external-entity-group/add`
    },
    promocodes: {
      list: `${coreRoutes.subscription}/promocodes`,
      edit: `${coreRoutes.subscription}/promocode/:id/edit`,
      add: `${coreRoutes.subscription}/promocode/add`
    }
  }

  // dashboard: `/dashboard`,
  // typography: `/typography`,
  // tables: `/tables`,
  // notifications: `/notifications`,
  // icons: `/icons`,
  // maps: `/maps`,
  // charts: `/charts`,
}

export const Routes = () => {
  return (
    <Switch>
      <Route exact path={NamedRoutes.home} component={Home} />
      <PrivateRoute exact path={NamedRoutes.editProfile} component={EditProfile} />
      {/*Workspace routes*/}
      <PrivateRoute exact path={NamedRoutes.workspace.user.list} component={Users} />
      <PrivateRoute exact path={NamedRoutes.workspace.user.addAdmin} component={AddAdmin} />
      <PrivateRoute exact path={NamedRoutes.workspace.user.editProfile} component={UserEditProfile} />
      <PrivateRoute exact path={NamedRoutes.workspace.user.companies} component={UserCompanies} />
      <PrivateRoute exact path={NamedRoutes.workspace.company.list} component={Companies} />
      <PrivateRoute exact path={NamedRoutes.workspace.company.users} component={CompanyUsers} />
      <PrivateRoute exact path={NamedRoutes.workspace.currencies.list} component={Currencies} />
      <PrivateRoute exact path={NamedRoutes.workspace.currencies.add} component={SingleCurrencyAdd} />
      <PrivateRoute exact path={NamedRoutes.workspace.currencies.edit} component={SingleCurrencyEdit} />
      <PrivateRoute exact path={NamedRoutes.workspace.payments} component={PaymentClaims} />
      <PrivateRoute exact path={NamedRoutes.workspace.paymentRequests} component={PaymentRequests} />
      <PrivateRoute exact path={NamedRoutes.workspace.paymentReceipts} component={PaymentReceipts} />
      <PrivateRoute exact path={NamedRoutes.workspace.page.list} component={Pages} />
      <PrivateRoute exact path={NamedRoutes.workspace.page.add} component={SinglePageAdd} />
      <PrivateRoute exact path={NamedRoutes.workspace.page.edit} component={SinglePageEdit} />
      <PrivateRoute exact path={NamedRoutes.workspace.settings} component={Settings} />
      <PrivateRoute exact path={NamedRoutes.workspace.ActivityLog} component={ActivityLog} />
      <PrivateRoute exact path={NamedRoutes.workspace.RolesAndPermissions.list} component={Roles} />
      <PrivateRoute exact path={NamedRoutes.workspace.RolesAndPermissions.add} component={SingleRoleAdd} />
      <PrivateRoute exact path={NamedRoutes.workspace.RolesAndPermissions.edit} component={SingleRoleEdit} />
      <PrivateRoute exact path={NamedRoutes.workspace.uptcp} component={UPTCP} />

      {/*Subscription routes*/}
      <PrivateRoute exact path={NamedRoutes.subscription.user.list} component={SubscriptionUsers} />
      <PrivateRoute exact path={NamedRoutes.subscription.user.addAdmin} component={AddAdmin} />
      <PrivateRoute exact path={NamedRoutes.subscription.user.editProfile} component={UserEditProfile} />
      <PrivateRoute exact path={NamedRoutes.subscription.page.list} component={Pages} />
      <PrivateRoute exact path={NamedRoutes.subscription.page.add} component={SinglePageAdd} />
      <PrivateRoute exact path={NamedRoutes.subscription.page.edit} component={SinglePageEdit} />
      <PrivateRoute exact path={NamedRoutes.subscription.settings} component={Settings} />
      <PrivateRoute exact path={NamedRoutes.subscription.ActivityLog} component={SubscriptionActivityLog} />

      <PrivateRoute exact path={NamedRoutes.subscription.category.list} component={Categories} />
      <PrivateRoute exact path={NamedRoutes.subscription.category.add} component={SingleCategoryAdd} />
      <PrivateRoute exact path={NamedRoutes.subscription.category.edit} component={SingleCategoryEdit} />

      <PrivateRoute exact path={NamedRoutes.subscription.userGroups.list} component={UserGroups} />
      <PrivateRoute exact path={NamedRoutes.subscription.userGroups.add} component={SingleUserGroupAdd} />
      <PrivateRoute exact path={NamedRoutes.subscription.userGroups.edit} component={SingleUserGroupEdit} />

      <PrivateRoute exact path={NamedRoutes.subscription.externalEntityGroups.list} component={ExternalEntityGroups} />
      <PrivateRoute exact path={NamedRoutes.subscription.externalEntityGroups.add} component={SingleExternalEntityGroupAdd}/>
      <PrivateRoute exact path={NamedRoutes.subscription.externalEntityGroups.edit} component={SingleExternalEntityGroupEdit}/>

      <PrivateRoute exact path={NamedRoutes.subscription.promocodes.list} component={Promocodes}/>
      <PrivateRoute exact path={NamedRoutes.subscription.promocodes.add} component={SinglePromocodeAdd}/>
      <PrivateRoute exact path={NamedRoutes.subscription.promocodes.edit} component={SinglePromocodeEdit}/>
      
      <PrivateRoute exact path={NamedRoutes.subscription.service.list} component={Services} />
      <PrivateRoute exact path={NamedRoutes.subscription.service.add} component={SingleServiceAdd} />
      <PrivateRoute exact path={NamedRoutes.subscription.service.edit} component={SingleServiceEdit} />

      <PrivateRoute exact path={NamedRoutes.subscription.plan.list} component={Plans} />
      <PrivateRoute exact path={NamedRoutes.subscription.plan.add} component={SinglePlanAdd} />
      <PrivateRoute exact path={NamedRoutes.subscription.plan.edit} component={SinglePlanEdit} />

      <PrivateRoute exact path={NamedRoutes.subscription.paymentRequests} component={SubscriptionPaymentRequests} />
      <PrivateRoute exact path={NamedRoutes.subscription.paymentReceipts} component={SubscriptionPaymentReceipts} />


      <PrivateRoute exact path={NamedRoutes.subscription.report.home} component={PlansReport} />
      <PrivateRoute exact path={NamedRoutes.subscription.report.plans} component={PlansReport} />
      <PrivateRoute exact path={NamedRoutes.subscription.report.services} component={ServicesReport} />
      <PrivateRoute exact path={NamedRoutes.subscription.report.subscriptions} component={SubscriptionsReport} />

      <PrivateRoute exact path={NamedRoutes.subscription.RolesAndPermissions.list} component={Roles} />
      <PrivateRoute exact path={NamedRoutes.subscription.RolesAndPermissions.add} component={SingleRoleAdd} />
      <PrivateRoute exact path={NamedRoutes.subscription.RolesAndPermissions.edit} component={SingleRoleEdit} />

      <Route exact path={NamedRoutes.unAuthorized} component={UnAuthorized} />
      <Route component={NoMatch} />

      {/*<Route exact path={NamedRoutes.dashboard} component={Dashboard}/>*/}
      {/*<Route exact path={NamedRoutes.typography} component={Typography}/>*/}
      {/*<Route exact path={NamedRoutes.tables} component={Tables}/>*/}
      {/*<Route exact path={NamedRoutes.notifications} component={Notifications}/>*/}
      {/*<Route exact path={NamedRoutes.icons} component={Icons}/>*/}
      {/*<Route exact path={NamedRoutes.maps} component={Maps}/>*/}
      {/*<Route exact path={NamedRoutes.charts} component={Charts}/>*/}
    </Switch>
  )
}
